import React from 'react';
import PropTypes from 'prop-types';
import { Dot } from 'react-animated-dots';

import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';
import Dialog from '../../../Dialog';
import { useTranslation } from 'react-i18next';

const PdfExportDialog = ({ open }) => {
	const { t } = useTranslation();
	const classes = useStyles();

	return (
		<Dialog
			open={open}
			fullWidth
			maxWidth={'sm'}
			content={
				<div className={classes.container}>
					<Typography variant="h6" align="center" className={classes.title}>
						{t('components.pdfExport.dialog.message1')}
						<Dot>.</Dot>
						<Dot>.</Dot>
						<Dot>.</Dot>
					</Typography>

					<Typography variant="body2" color="textSecondary" align="center">
						{t('components.pdfExport.dialog.message2')}
					</Typography>
				</div>
			}
		/>
	);
};

PdfExportDialog.propTypes = {
	open: PropTypes.bool.isRequired
};

export default PdfExportDialog;
